import { useEffect, useState } from 'react';
import { ImageGeneration } from './ImageGeneration';
import type { imageToolCall } from '../../types/message';

const swatch = (from: string, to: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="700" height="700"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/></linearGradient></defs><rect width="700" height="700" fill="url(#g)"/></svg>`
  )}`;

const imageCall: imageToolCall = {
  numberOfImages: 3,
  isLoading: false,
  isError: false,
  imageGenerationId: 'preview',
  prompt: 'Preview',
  urls: [swatch('#f5f5f0', '#e0e0dc'), swatch('#2d3a2a', '#6b7f5a'), swatch('#1a1a2e', '#e94560')],
};

const GENERATION_MS = 6000;

export const ImageGenerationPreview = () => {
  const [run, setRun] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timeout = window.setTimeout(() => setIsLoading(false), GENERATION_MS);
    return () => window.clearTimeout(timeout);
  }, [run]);

  const simulated: imageToolCall = {
    ...imageCall,
    imageGenerationId: `preview-${run}`,
    numberOfImages: 2,
    isLoading,
    // Cache-busting fragment so each run decodes fresh and plays the reveal.
    urls: isLoading ? [] : imageCall.urls.slice(1).map(url => `${url}<!--${run}-->`),
  };

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ marginBottom: 8 }}>Image Generation</h1>
      <p style={{ marginBottom: 16 }}>Hover an image to reveal the download button.</p>
      <ImageGeneration imageGeneration={imageCall} isMessageGenerating={false} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, margin: '32px 0 16px' }}>
        <h2>Generating</h2>
        <button
          onClick={() => setRun(current => current + 1)}
          style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid var(--border-color)' }}
        >
          Replay
        </button>
      </div>
      <ImageGeneration key={run} imageGeneration={simulated} isMessageGenerating />
    </div>
  );
};
